import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
import { buyers } from '../data/content';
const FIRST_DELAY = 5000;
const VISIBLE_FOR = 5000;
const GAP = 7000;
const minutesAgo = [2, 4, 7, 3, 11, 6, 9, 5, 14];
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    const timer = window.setTimeout(() => {
      if (visible) {
        setVisible(false);
        setIndex(current => (current + 1) % buyers.length);
      } else {
        setVisible(true);
      }
    }, visible ? VISIBLE_FOR : index === 0 ? FIRST_DELAY : GAP);
    return () => window.clearTimeout(timer);
  }, [visible, index, dismissed]);
  const [name, city] = buyers[index];
  return <div className="pointer-events-none fixed bottom-24 left-3 z-[60] md:bottom-6 md:left-6" aria-live="polite" data-id="element-339" data-mp="1gydz6bls19oq">
      <AnimatePresence data-id="element-340" data-mp="116w8qmig77du">
        {visible && !dismissed && <motion.div key={name} initial={{
        opacity: 0,
        x: -24,
        scale: 0.96
      }} animate={{
        opacity: 1,
        x: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        x: -24,
        scale: 0.96
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex w-[270px] items-center gap-3 rounded-xl border-[3px] border-sky-600 bg-yellow-300 p-3 pr-8 shadow-xl shadow-slate-900/20" data-id="element-341" data-mp="116cyzt2ybpaw">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-sky-600 text-white" data-id="element-342" data-mp="x6cblixvk3rp">
              <ShoppingBagIcon className="h-5 w-5" data-id="element-343" data-mp="s4my7wn6je0g" />
            </span>
            <p className="text-xs leading-snug text-slate-900" data-id="element-344" data-mp="28joki88hrckq">
              <b className="font-black" data-id="element-345" data-mp="28mandukft3wm">{name}</b> de {city}, Argentina
              <span className="block font-semibold" data-id="element-346" data-mp="23l3ic39oiitn">
                compró <b className="font-black" data-id="element-347" data-mp="2apcrmzy5v1hx">Muebles Fáciles en Casa</b>
              </span>
              <span className="block text-[11px] font-semibold text-slate-700" data-id="element-348" data-mp="2fn4taloly1zb">
                hace {minutesAgo[index % minutesAgo.length]} minutos ✓
              </span>
            </p>
            <button onClick={() => setDismissed(true)} className="absolute right-1.5 top-1.5 rounded p-0.5 text-slate-700 hover:text-slate-900" aria-label="Cerrar notificación" data-id="element-349" data-mp="2plk9vuq0dsuk">
              <XIcon className="h-3.5 w-3.5" data-id="element-350" data-mp="1wy7x2c9ngzeg" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}